<template>
  <custom-modal :size="'max-w-xl'">
    <template v-slot:maincontent>
    <div class="w-full h-auto">
        <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
          <div class="bg-theme-green px-4 py-2 text-white">
            <div class="flex justify-between items-center">
              <div class="flex flex-col justify-start text-start ">
                <h2 class="font-semibold truncate text-single-line break-all mb-0.5 text-xl leading-6 mt-0 ml-2">Add/Remove Cash</h2>
              </div>
              
              <div class="flex flex-col">
                <div class="flex items-center content-center gap-2">
                  <button @click.prevent="close" class="text-sm flex items-center justify-center text-center w-[100px] h-[44px] tracking-[0.15px] font-medium cursor-pointer hover:bg-white border border-white p-4 rounded hover:text-theme-green  text-white ml-3">CANCEL</button>
                  <button @click.prevent="saveAddCash" class="text-sm flex items-center justify-center text-center w-[100px] h-[44px] tracking-[0.15px] font-medium cursor-pointer bg-white p-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white ml-3">
                    <span>SAVE</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class=" bg-[#2B2C32] px-[16px] py-[16px] rounded-b-lg">
            <div class="w-full">
                <div class="input-wrapper h-[60px] relative">
                    <label class="text-xs tracking-[0.4px]">Adjustment Type</label>
                    <div class="flex items-center">
                      <div class="flex items-center">
                        <input id="cash" name="cash" type="radio" v-model="form.transactionType.value" value="add cash" class="w-4 h-4  bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                        <label for="cash" class="ml-2 text-sm font-normal tracking-wider text-white dark:text-gray-300">Add Cash</label>
                      </div>
                      <div class="flex items-center ml-[100px]">
                        <input id="cash" name="cash" type="radio" v-model="form.transactionType.value" value="remove cash" class="w-4 h-4  bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                        <label for="cash" class="ml-2 text-sm font-normal tracking-wider text-white dark:text-gray-300">Remove Cash</label>
                      </div>
                    </div>
                </div>
            </div>
          
            <div class="w-full">
              <div class="mb-2" :class="'input-wrapper ' + (form.amount.error_type)">
                <label class="text-xs tracking-[0.4px]">Amount</label>
                <div class="relative">
                  <input @keyup="validateFields(['amount'])" v-model="form.amount.value" placeholder="ei. $100.00" class="block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm" type="number">
                  <p class="field-error label-text mt-1" v-if="form.amount.error_message" v-text="form.amount.error_message"></p>
                </div>
              </div>
            </div>

            <div class="w-full">
              <div class="relative" :class="'input-wrapper ' + (form.note.error_type)">
                <label class="text-xs tracking-[0.4px]">Notes</label>
                <textarea @keyup="validateFields(['note'])" v-model="form.note.value" placeholder="Add a note here" class="block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm"></textarea>
                <p class="field-error label-text mt-1" v-if="form.note.error_message" v-text="form.note.error_message"></p>
              </div>
            </div>
          </div>
        </div>
    </div>
    </template>
  </custom-modal>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import VaultApis from '@/controllers/VaultApis'
import Helpers from '@/helpers';
import { mapGetters, mapActions } from "vuex";
import { useSnackbar } from "vue3-snackbar";

export default defineComponent({
  name: "AddCash",
  setup() {
    const form = ref({
      transactionType: {
        value: 'add cash',
        error_type: '',
        error_message: ''
      },
      amount: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required']
      }, 
      note: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required']
      }
    })
    const snackbar = useSnackbar();

    return {form, snackbar}
  },
  computed: {
    ...mapGetters({
      vg_selectedLocation: 'location/selected'
    })
  },
  methods: {
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },
    close(){
      this.$emit('close', false)
    },
    async saveAddCash(){
      let validate = await this.validateFields(['amount', 'note']);
      if(!validate) {
        return ;
      }

      this.va_spinner(true)
      let res = await VaultApis.create({
        locationId: this.vg_selectedLocation.id,
        amount: this.form.amount.value,
        transactionType: this.form.transactionType.value,
        note: this.form.note.value
      })
      if(res.status==201){
        this.snackbar.add({
          type: 'info',
          text: res.status == 201 ? this.getMessage(res): Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
        this.$emit('close', true)
      }
      this.va_spinner(false)
    },
    getMessage(res){
      if(this.form.transactionType.value=='add cash'){
        return 'Cash added.'
      }else if(this.form.transactionType.value=='remove cash'){
        return 'Cash removed.'
      }else{
        return res.data.message
      }
    },
    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })
  }
});

</script>
